import React from "react";

export const OrderStatusBadge = ({ status }) => {
  const map = {
    pending: { label: "Pending", cls: "status-pending" },
    confirmed: { label: "Confirmed", cls: "status-confirmed" },
    preparing: { label: "Preparing", cls: "status-preparing" },
    ready: { label: "Ready", cls: "status-ready" },
    delivered: { label: "Delivered", cls: "status-delivered" },
    cancelled: { label: "Cancelled", cls: "status-cancelled" },
  };
  const { label, cls } = map[status] || { label: status, cls: "" };
  return <span className={`badge ${cls}`}>{label}</span>;
};

export const StarRating = ({ rating, onChange, size = "md" }) => {
  const s = size === "sm" ? "text-sm" : size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange && onChange(star)}
          className={`${s} transition-transform hover:scale-110 ${onChange ? "cursor-pointer" : "cursor-default"}`}
        >
          <span className={star <= rating ? "star" : "star-empty"}>★</span>
        </button>
      ))}
    </div>
  );
};

export const Spinner = ({ size = "md" }) => {
  const s = size === "sm" ? "w-4 h-4" : size === "lg" ? "w-10 h-10" : "w-6 h-6";
  return (
    <div className={`${s} border-2 border-orange-500 border-t-transparent rounded-full animate-spin`} />
  );
};

export const EmptyState = ({ icon = "🍽️", title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-16 text-center">
    <div className="text-5xl mb-4 opacity-50">{icon}</div>
    <h3 className="font-display font-bold text-xl text-gray-700">{title}</h3>
    {description && <p className="text-gray-500 mt-2 max-w-sm">{description}</p>}
    {action && <div className="mt-6">{action}</div>}
  </div>
);

export const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel, danger }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl animate-scale-in">
        <h3 className="font-display font-bold text-lg text-gray-900">{title}</h3>
        <p className="mt-2 text-gray-600 text-sm">{message}</p>
        <div className="flex gap-3 mt-6">
          <button onClick={onCancel} className="flex-1 btn-ghost border border-gray-200">Cancel</button>
          <button
            onClick={onConfirm}
            className={`flex-1 font-semibold py-3 rounded-xl transition-all ${
              danger ? "bg-red-500 hover:bg-red-600 text-white" : "btn-primary"
            }`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export const PageWrapper = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 page-enter ${className}`}>
    {children}
  </div>
);
